module.exports = __webpack_public_path__ + "img/hopways-02.5e62a149.jpeg";